import styled from "styled-components";

export const Container = styled.div``;
export const Content = styled.div`
  box-shadow: var(--box-shadow);
  max-width: 600px;
  padding-bottom: 10px;
  background: var(--background-color);
  border-radius: 4px;
  border: 1px solid #eee;
`;

export const Title = styled.h3`
  padding: 16px 24px;
  color: var(--color);
  border-bottom: 1px solid #eee;
  text-align: center;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #eee;
`;

export const Td = styled.td`
  padding: 16px;
  text-align: center;
  color: var(--color);
  vertical-align: middle;
`;

export const Usuario = styled.span`
  text-transform: uppercase;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: var(--color);
  width: 50px;
  height: 50px;
  background: var(--primary);
  border-radius: 50%;
`;

export const Status = styled.span`
  color: var(--color);
  background: #0f0;
  padding: 5px 10px;
  border-radius: 4px;
  text-transform: uppercase;
`;
